import { render } from "./ComplexProjectCard.vue?vue&type=template&id=3d4569e9"
import script from "./ComplexProjectCard.vue?vue&type=script&lang=js"
export * from "./ComplexProjectCard.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__